import { render, staticRenderFns } from "./MessageDeny.vue?vue&type=template&id=3bc4da12&scoped=true&"
import script from "./MessageDeny.vue?vue&type=script&lang=js&"
export * from "./MessageDeny.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc4da12",
  null
  
)

export default component.exports